<template>
  <div class="ad-filters">
    <div class="ad-filters__top">
      <div class="ad-filters__top-left">
        <div class="ad-filters__top-left--search">
          <div class="search-container">
            <v-icon class="icon">mdi-magnify</v-icon>
            <input type="text" placeholder="Search" v-model="searchValue" @input="onFilterChange">
          </div>
        </div>
        <div class="ad-filters__top-left--delimetr"></div>
        <div class="ad-filters__top-left--add" v-click-outside="closeAddFiltersMenu">
          <button class="ad-filters__top-left--add--button"
            v-if="!activeFiltersList.length"
            @click="showAddFiltersMenu = !showAddFiltersMenu">
            <v-icon class="icon">mdi-plus</v-icon>
            <span>Add filter/grouping</span>
          </button>
          <button class="ad-filters__top-left--add--button"
            v-if="activeFiltersList.length && !showFiltersBottomSection"
            @click="showFiltersBottomSection = true">
            <v-icon class="icon">mdi-eye-outline</v-icon>
            <span>Show filters ({{ activeFiltersList.length }})</span>
          </button>
          <button class="ad-filters__top-left--add--button"
            v-if="activeFiltersList.length && showFiltersBottomSection"
            @click="showFiltersBottomSection = false">
            <v-icon class="icon">mdi-eye-off-outline</v-icon>
            <span>Hide filters ({{ activeFiltersList.length }})</span>
          </button>
          <div class="submenu" v-if="showAddFiltersMenu">
            <div class="submenu-item">
              <div class="submenu-item--search">
                <div class="search-container">
                  <v-icon class="icon">mdi-magnify</v-icon>
                  <input type="text" placeholder="Filter by..." v-model="searchFilters">
                </div>
              </div>
            </div>
            <div class="submenu-item--title" v-if="assignmentFiltersList.length">
              <p class="submenu-item--title--text">Assignment filters</p>
            </div>
            <div class="submenu-item--filter" 
              @click="addFilter(filter)"
              v-for="(filter) in assignmentFiltersList" 
              :key="filter.id">
              <div class="submenu-item--filter--icon">
                <ad_filters_icons 
                  :icon="filter.icon"
                  />
              </div>
              <p class="submenu-item--filter--text">
                {{ filter.title }}
              </p>
            </div>
            <div class="submenu-item--title" v-if="assignmentGroupingList.length">
              <p class="submenu-item--title--text">Assignment grouping</p>
            </div>
            <div class="submenu-item--filter" 
              @click="addFilter(filter)"
              v-for="(filter) in assignmentGroupingList" 
              :key="filter.id">
              <div class="submenu-item--filter--icon">
                <ad_filters_icons 
                  :icon="filter.icon"
                  />
              </div>
              <p class="submenu-item--filter--text">
                {{ filter.title }}
              </p>
            </div>
            <div class="submenu-item--title" v-if="!assignmentFiltersList.length && !assignmentGroupingList.length">
              <p class="submenu-item--title--text">No results</p>
            </div>
          </div>
        </div>
        <div class="ad-filters__top-left--delimetr"></div>
        <div class="ad-filters__top-left--add">
          <button class="ad-filters__top-left--add--button"
            @click="clearAll">
            <v-icon class="icon">mdi-trash-can-outline</v-icon>
            <span>Clear all</span>
          </button>
        </div>
      </div>
      <div class="ad-filters__top-right">
        <div class="ad-filters__top-right--new-task">
          <button class="ad-filters__top-right--new-task--button" @click="$emit('new-assignment', true)">
            <v-icon class="icon" color="white">mdi-shape-plus-outline</v-icon>
            <span>New assignment</span>
          </button>
        </div>
        <div class="ad-filters__top-right--options" v-click-outside="closeAdditionalMenu">
          <button class="ad-filters__top-right--options--button"
            @click="showAditionalOptions = !showAditionalOptions">
            <v-icon class="icon">mdi-dots-horizontal</v-icon>
          </button>
          <div class="options-dropdown" v-if="showAditionalOptions">
            <button class="options-dropdown__item"
              @click="showCurrentFiltersModal">
              Enable invoice view mode
            </button>
            <button class="options-dropdown__item"
              @click="showCurrentFiltersModal">
              Download invoice (483.25$)
            </button>
            <button class="options-dropdown__item"
              @click="saveCurrentPreset">
              Save current filters preset
            </button>
            <div class="options-dropdown__item with-submenu">
              <button @click="showAditionalOptionsSubMenuModal = !showAditionalOptionsSubMenuModal">Load filters preset</button>
              <div class="submenu" v-if="showAditionalOptionsSubMenuModal">
                <div class="submenu-item"
                  @click="useFilterPreset(preset)"
                  v-if="presetsFiltersList.length"
                  v-for="(preset, index) in presetsFiltersList"
                  :key="index">
                  <p class="submenu-item--text">{{ preset }}</p>
                  <button class="submenu-item--button"
                    @click="removePreset(preset)">
                    <v-icon class="icon">mdi-trash-can-outline</v-icon>
                  </button>
                </div>
                <div class="submenu-item" v-else>
                  <p class="submenu-item--text">No saved filters</p>
                </div>
              </div>
            </div>
            <!-- Only available once at least one table row is checked. -->
            <button class="options-dropdown__item"
              v-if="selectedDashboardRows.length"
              @click="callBatchEdit">
              Batch edit selected
            </button>
          </div>
        </div>
      </div>
    </div>
    <transition name="submenu-transition">
    <div class="ad-filters__bottom" 
      v-if="activeFiltersList.length && showFiltersBottomSection">
      <div class="ad-filters__bottom--list"
        v-for="activeFilter in activeFiltersList"
        :key="activeFilter.id">
        <div class="list-item with-submenu" 
          v-if="activeFilter.section === 'assignment'"
          v-click-outside="() => closeInputFilterModal(activeFilter)">
          <div class="list-item--icon"
            @click="showActiveFilterMenu(activeFilter)">
            <ad_filters_icons 
              :icon="activeFilter.icon"
              />
            <p class="list-item--icon-text">
              {{ activeFilter.title }}
            </p>
          </div>
          <div class="list-item--text"
            @click="showActiveFilterMenu(activeFilter)"
            v-if="activeFilter.value && activeFilter.value.length && activeFilter.title === 'DRI'">
            <div class="users-list__item">
              <div class="users-list__item-container">
                <div class="users-list__item-container--avatar"
                  :style="`background-color: ${preparedStaff.find((staffItem) => staffItem.id === activeFilter.value[0]).color};`">{{ preparedStaff.find((staffItem) => staffItem.id === activeFilter.value[0]).shortName }}</div>
                <p class="users-list__item-container--name">{{ preparedStaff.find((staffItem) => staffItem.id === activeFilter.value[0]).name }}</p>
              </div>
              <p class="users-list__item--more" v-if="activeFilter.value.length > 1">, +{{ activeFilter.value.length - 1 }}</p>
            </div>
          </div>
          <div class="list-item--text"
            @click="showActiveFilterMenu(activeFilter)"
            v-if="activeFilter.value && activeFilter.value.length && activeFilter.title === 'Task Status'">
            <div class="users-list__item">
              <div class="users-list__item-container">
                <p class="users-list__item-container--name">{{ activeFilter.value[0] }}</p>
              </div>
              <p class="users-list__item--more" v-if="activeFilter.value.length > 1">, +{{ activeFilter.value.length - 1 }}</p>
            </div>
          </div>
          <div class="list-item--text"
            @click="showActiveFilterMenu(activeFilter)"
            v-if="activeFilter.value && activeFilter.value.length && activeFilter.title === 'Action Required'">
            <div class="users-list__item">
              <div class="users-list__item-container">
                <p class="users-list__item-container--name">{{ activeFilter.value[0] }}</p>
              </div>
              <p class="users-list__item--more" v-if="activeFilter.value.length > 1">, +{{ activeFilter.value.length - 1 }}</p>
            </div>
          </div>
          <div class="list-item--text"
            @click="showActiveFilterMenu(activeFilter)"
            v-if="activeFilter.value && activeFilter.value.length && activeFilter.title === 'Person'">
            <div class="users-list__item">
              <div class="users-list__item-container">
                <p class="users-list__item-container--name">{{ activeFilter.value[0] }}</p>
              </div>
              <p class="users-list__item--more" v-if="activeFilter.value.length > 1">, +{{ activeFilter.value.length - 1 }}</p>
            </div>
          </div>
          <div class="list-item--text"
            @click="showActiveFilterMenu(activeFilter)"
            v-if="activeFilter.value && activeFilter.title !== 'DRI' && activeFilter.title !== 'Task Status' && activeFilter.title !== 'Action Required' && activeFilter.title !== 'Person'">
            {{ activeFilter.value }}
          </div>
          <div class="submenu" v-if="activeFilter.showFilterInputMenu">
            <div class="submenu-item with-submenu">
              <span class="submenu-item--text">{{ activeFilter.title }}</span>
              <div class="submenu-item--dropdown"
                @click="showActiveFilterSubMenu(activeFilter)">
                <p class="sec-submenu--dropdown-text">{{ activeFilter.filterType }}</p>
                <div class="sec-submenu--dropdown-icon">
                  <v-icon class="icon">mdi-menu-down</v-icon>
                </div>
              </div>
              <div class="sec-submenu" v-if="activeFilter.showFilterSubMenu">
                <p class="sec-submenu--option" 
                v-for="filterType in activeFilter.filterTypeOptions"
                @click="setFilterType(activeFilter, filterType)">
                  {{ filterType }}
                </p>
              </div>
            </div>
            <div class="submenu__value">
              <div class="submenu__value--container with-submenu"
                v-if="activeFilter.title === 'Pay Period'">
                <input
                  type="text" 
                  placeholder="Choose date..."
                  @click="payPeriodDatePicker = !payPeriodDatePicker"
                  :value="payPeriodFormatter(activeFilter.value)"/>
                <v-icon
                  class="icon"
                  @click="clearFilterValue(activeFilter)">
                  mdi-close
                </v-icon>
                <div class="date-picker" v-if="payPeriodDatePicker">
                  <v-date-picker
                    @input="payPeriodDatePicker = false; onFilterChange()"
                    v-model="activeFilter.value"
                    type="month"
                  ></v-date-picker>
                </div>
              </div>
              <div class="submenu__value--container with-submenu"
                v-else-if="
                  activeFilter.title === 'Request Date'
                  || activeFilter.title === 'Delivery Date'
                  ">
                <input
                  type="text" 
                  placeholder="Choose date..."
                  @click="periodDatePicker = !periodDatePicker"
                  :value="periodFormatter(activeFilter.value)"/>
                <v-icon
                  class="icon"
                  @click="clearFilterValue(activeFilter)">
                  mdi-close
                </v-icon>
                <div class="date-picker" v-if="periodDatePicker">
                  <v-date-picker
                    @input="periodDatePicker = false; onFilterChange()"
                    v-model="activeFilter.value"
                  ></v-date-picker>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="
                  activeFilter.title === 'DRI'">
                <div class="users-container">
                  <input
                    type="text" 
                    placeholder="Type a name..."
                    v-model="driNameSearch"/>
                  <v-icon
                    class="icon"
                    @click="driNameSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list">
                  <div class="users-list__item"
                    @click="setDRIFilterValue(activeFilter, staffItem)"
                    v-for="staffItem in preparedStaff" 
                    :key="staffItem.id">
                    <div class="users-list__item-container">
                      <div class="users-list__item-container--avatar"
                        :style="{ 'background-color': staffItem.color }">
                        {{ staffItem.shortName }}
                      </div>
                      <p class="users-list__item-container--name">{{ staffItem.name }}</p>
                    </div>
                    <div class="users-list__item--check" v-if="activeFilter.value.includes(staffItem.id)">
                      <v-icon class="icon">mdi-check</v-icon>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container" v-else-if="activeFilter.title === 'Task Status'">
                <input type="text"
                  placeholder="Select a value..."
                  readonly
                  :value="activeFilter.value.length ? activeFilter.value.join(',') : ''"
                  @focus="showTaskStatusSubmenuList = !showTaskStatusSubmenuList"/>
                <v-icon
                  class="icon"
                  @click="clearFilterValue(activeFilter)">
                  mdi-close
                </v-icon>
                <div class="submenu" style="top: 100px; width: 150px" v-if="showTaskStatusSubmenuList">
                  <div class="submenu-item flex align-center justify-space-between" 
                    v-for="status in taskStatuses" 
                    :key="status"
                    @click="addTaskStatusFilterValue(activeFilter, status)">
                    <p class="submenu-item--text mb-2">{{ status }}</p>
                    <button class="submenu-item--button" 
                      v-if="activeFilter.value.includes(status)" >
                      <v-icon class="icon">mdi-check</v-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container" v-else-if="activeFilter.title === 'Action Required'">
                <input type="text"
                  placeholder="Select a value..."
                  readonly
                  :value="activeFilter.value.length ? activeFilter.value.join(',') : ''"
                  @focus="showActionRequiredStatusSubmenuList = !showActionRequiredStatusSubmenuList"/>
                <v-icon
                  class="icon"
                  @click="clearFilterValue(activeFilter)">
                  mdi-close
                </v-icon>
                <div class="submenu" style="top: 100px; width: 150px" v-if="showActionRequiredStatusSubmenuList">
                  <div class="submenu-item flex align-center justify-space-between" 
                    v-for="status in taskStatuses" 
                    :key="status"
                    @click="addTaskStatusFilterValue(activeFilter, status)">
                    <p class="submenu-item--text mb-2">{{ status }}</p>
                    <button class="submenu-item--button" 
                      v-if="activeFilter.value.includes(status)" >
                      <v-icon class="icon">mdi-check</v-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="
                  activeFilter.title === 'Project'">
                <div class="users-container">
                  <input
                    type="text" 
                    placeholder="Type a project name..."
                    v-model="projectSearch"/>
                  <v-icon
                    class="icon"
                    @click="projectSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list project-list">
                  <div class="users-list__item"
                    @click="activeFilter.value = project.projectName; onFilterChange()"
                    v-for="project in preperedProjectsList"
                    :key="project.id">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">{{ project.projectName }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="activeFilter.title === 'GEO'">
                <div class="users-container">
                  <input
                    type="text"
                    placeholder="Search GEO..."
                    v-model="geoSearch"/>
                  <v-icon
                    class="icon"
                    @click="geoSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list geo-list">
                  <div class="users-list__item"
                    @click="setGeoFilterValue(activeFilter, geo)"
                    v-for="(geo, index) in preparedGeos"
                    :key="index">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">{{ geo }}</p>
                    </div>
                    <div class="users-list__item--check" v-if="activeFilter.value === geo">
                      <v-icon class="icon">mdi-check</v-icon>
                    </div>
                  </div>
                  <div class="users-list__item" v-if="!preparedGeos.length">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">No results</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="activeFilter.title === 'Keyword'">
                <div class="users-container">
                  <input
                    type="text"
                    placeholder="Search Keyword..."
                    v-model="keywordSearch"/>
                  <v-icon
                    class="icon"
                    @click="keywordSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list enum-list">
                  <div class="users-list__item"
                    @click="setKeywordFilterValue(activeFilter, keyword)"
                    v-for="(keyword, index) in preparedKeywords"
                    :key="index">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">{{ keyword }}</p>
                    </div>
                    <div class="users-list__item--check" v-if="activeFilter.value === keyword">
                      <v-icon class="icon">mdi-check</v-icon>
                    </div>
                  </div>
                  <div class="users-list__item" v-if="!preparedKeywords.length">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">No results</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="activeFilter.title === 'Media Type'">
                <div class="users-container">
                  <input
                    type="text"
                    placeholder="Search Media Type..."
                    v-model="mediaTypeSearch"/>
                  <v-icon
                    class="icon"
                    @click="mediaTypeSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list enum-list">
                  <div class="users-list__item"
                    @click="setMediaTypeFilterValue(activeFilter, mediaType)"
                    v-for="(mediaType, index) in preparedMediaTypes"
                    :key="index">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">{{ mediaType }}</p>
                    </div>
                    <div class="users-list__item--check" v-if="activeFilter.value === mediaType">
                      <v-icon class="icon">mdi-check</v-icon>
                    </div>
                  </div>
                  <div class="users-list__item" v-if="!preparedMediaTypes.length">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">No results</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="activeFilter.title === 'Request Type'">
                <div class="users-container">
                  <input
                    type="text"
                    placeholder="Search Request Type..."
                    v-model="requestTypeSearch"/>
                  <v-icon
                    class="icon"
                    @click="requestTypeSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list enum-list">
                  <div class="users-list__item"
                    @click="setRequestTypeFilterValue(activeFilter, requestType)"
                    v-for="(requestType, index) in preparedRequestTypes"
                    :key="index">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">{{ requestType }}</p>
                    </div>
                    <div class="users-list__item--check" v-if="activeFilter.value === requestType">
                      <v-icon class="icon">mdi-check</v-icon>
                    </div>
                  </div>
                  <div class="users-list__item" v-if="!preparedRequestTypes.length">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">No results</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="activeFilter.title === 'Person'">
                <div class="users-container">
                  <input
                    type="text"
                    placeholder="Type a name..."
                    v-model="personSearch"/>
                  <v-icon
                    class="icon"
                    @click="personSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list person-list">
                  <div class="users-list__item"
                    @click="setPersonFilterValue(activeFilter, person)"
                    v-for="person in preparedPersons"
                    :key="person.id">
                    <div class="users-list__item-container">
                      <div class="users-list__item-container--avatar"
                        :style="{ 'background-color': person.color }">
                        {{ person.shortName }}
                      </div>
                      <p class="users-list__item-container--name">{{ person.name }}</p>
                    </div>
                    <div class="users-list__item--check" v-if="activeFilter.value.includes(person.name)">
                      <v-icon class="icon">mdi-check</v-icon>
                    </div>
                  </div>
                  <div class="users-list__item" v-if="!preparedPersons.length">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">No results</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="activeFilter.title === 'Role'">
                <div class="users-container">
                  <input
                    type="text"
                    placeholder="Search Role..."
                    v-model="roleSearch"/>
                  <v-icon
                    class="icon"
                    @click="roleSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list enum-list">
                  <div class="users-list__item"
                    @click="setRoleFilterValue(activeFilter, role)"
                    v-for="(role, index) in preparedRoles"
                    :key="index">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">{{ role }}</p>
                    </div>
                    <div class="users-list__item--check" v-if="activeFilter.value === role">
                      <v-icon class="icon">mdi-check</v-icon>
                    </div>
                  </div>
                  <div class="users-list__item" v-if="!preparedRoles.length">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">No results</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container container-users with-submenu"
                v-else-if="activeFilter.title === 'Status'">
                <div class="users-container">
                  <input
                    type="text"
                    placeholder="Search Status..."
                    v-model="statusSearch"/>
                  <v-icon
                    class="icon"
                    @click="statusSearch = ''">
                    mdi-close
                  </v-icon>
                </div>
                <div class="users-list enum-list">
                  <div class="users-list__item"
                    @click="setStatusFilterValue(activeFilter, status)"
                    v-for="(status, index) in preparedStatuses"
                    :key="index">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">{{ status }}</p>
                    </div>
                    <div class="users-list__item--check" v-if="activeFilter.value === status">
                      <v-icon class="icon">mdi-check</v-icon>
                    </div>
                  </div>
                  <div class="users-list__item" v-if="!preparedStatuses.length">
                    <div class="users-list__item-container pa-2">
                      <p class="users-list__item-container--name">No results</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submenu__value--container" v-else>
                <input type="text" placeholder="Type a value..." v-model="activeFilter.value" @input="onFilterChange"/>
                <v-icon
                  class="icon"
                  @click="clearFilterValue(activeFilter)">
                  mdi-close
                </v-icon>
              </div>
            </div>
          </div>
          <div class="list-item--remove"
            @click="removeFilter(activeFilter)">
            <ad_filters_icons 
              :icon="'cross'"
              />
          </div>
        </div>
        <div class="list-item list-item--group-by"
          v-if="activeFilter.section === 'task'">
            <div class="list-item--icon">
              <p class="list-item--icon-text">
                Group by
              </p>
            </div>
            <div class="list-item--text">
              <ad_filters_icons :icon="activeFilter.icon" />
              <p class="group-by-value--name">
                {{ groupingLabel(activeFilter.title) }}
              </p>
            </div>
            <div class="list-item--remove"
              @click="removeFilter(activeFilter)">
              <ad_filters_icons :icon="'cross'" />
            </div>
        </div>
      </div>
      <div class="ad-filters__top-left--add" v-click-outside="closeAddFiltersMenu2">
        <button class="ad-filters__top-left--add--button"
          style="padding: 8px 10px;"
          v-if="activeFiltersList.length"
          @click="showAddFiltersMenu2 = !showAddFiltersMenu2">
          <v-icon class="icon">mdi-plus</v-icon>
          <span>Add filter/grouping</span>
        </button>
        <div class="submenu" v-if="showAddFiltersMenu2">
          <div class="submenu-item">
            <div class="submenu-item--search">
              <div class="search-container">
                <v-icon class="icon">mdi-magnify</v-icon>
                <input type="text" placeholder="Search" v-model="searchFilters">
              </div>
            </div>
          </div>
          <div class="submenu-item--title" v-if="assignmentFiltersList.length">
            <p class="submenu-item--title--text">Assignment filters</p>
          </div>
          <div class="submenu-item--filter" 
            @click="addFilter(filter)"
            v-for="(filter) in assignmentFiltersList" 
            :key="filter.id">
            <div class="submenu-item--filter--icon">
              <ad_filters_icons 
                :icon="filter.icon"
                />
            </div>
            <p class="submenu-item--filter--text">
              {{ filter.title }}
            </p>
          </div>
          <div class="submenu-item--title" v-if="assignmentGroupingList.length">
            <p class="submenu-item--title--text">Assignment grouping</p>
          </div>
          <div class="submenu-item--filter" 
            @click="addFilter(filter)"
            v-for="(filter) in assignmentGroupingList" 
            :key="filter.id">
            <div class="submenu-item--filter--icon">
              <ad_filters_icons 
                :icon="filter.icon"
                />
            </div>
            <p class="submenu-item--filter--text">
              {{ filter.title }}
            </p>
          </div>
          <div class="submenu-item--title" v-if="!assignmentFiltersList.length && !assignmentGroupingList.length">
            <p class="submenu-item--title--text">No results</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ad_filters_icons from '@/assets/icons/ad_filters_icons.vue';
import { alphabetColors, managersDesiredColors } from "@/utils/constants.js";

// Auto-restored "current filters" preset (single slot, separate from the
// named presets kept under 'pm-dashboard-filters').
const FILTERS_PRESET_KEY = "cue-dashboard-filters-preset";

export default {
  name: 'ADFilters',
  components: {
    ad_filters_icons,
  },
  props: {
    staff: {
      type: Array,
      default: [],
    },
    projectsList: {
      type: Array,
      default: [],
    },
    geos: {
      type: Array,
      default: () => [],
    },
    keywords: {
      type: Array,
      default: () => [],
    },
    mediaTypes: {
      type: Array,
      default: () => [],
    },
    requestTypes: {
      type: Array,
      default: () => [],
    },
    statuses: {
      type: Array,
      default: () => [],
    },
    roles: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      showAditionalOptions: false,
      showAditionalOptionsSubMenuModal: false,
      showAddFiltersMenu: false,
      showAddFiltersMenu2: false,
      searchValue: '',
      searchFilters: '',
      driNameSearch: '',
      payPeriodDatePicker: false,
      periodDatePicker: false,
      savedPresetsList: null,
      defaultAssignmentFiltersList: [
        { section: 'assignment', title: 'Parent Task', icon: 'arrow_top_bold', id: 1, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: ['is', 'is not'] },
        { section: 'assignment', title: 'Pay Period', icon: 'money-bill-wave', id: 2, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: ['is', 'is not'] },
        { section: 'assignment', title: 'Request Date', icon: 'calendar-right-arrow', id: 3, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: ['is', 'is on or before', 'is on or after', 'is between'] },
        { section: 'assignment', title: 'Delivery Date', icon: 'delivery-date', id: 4, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: [ 'is', 'is on or before', 'is on or after', 'is between'] },
        { section: 'assignment', title: 'Project', icon: 'book-bookmark', id: 5, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: ['is', 'is not'] },
        { section: 'assignment', title: 'GEO', icon: 'world', id: 6, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: [ 'is', 'is not'] },
        { section: 'assignment', title: 'Person', icon: 'user', id: 7, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: [ 'is', 'is not'] },
        { section: 'assignment', title: 'Role', icon: 'user_and_will', id: 8, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: [ 'is', 'is not'] },
        { section: 'assignment', title: 'Status', icon: 'status_light', id: 9, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: [ 'is', 'is not'] },
        { section: 'assignment', title: 'Keyword', icon: 'palms', id: 10, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: [ 'is', 'is not'] },
        { section: 'assignment', title: 'Media Type', icon: 'painting', id: 11, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: [ 'is', 'is not'] },
        { section: 'assignment', title: 'Request Type', icon: 'circles', id: 12, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: [ 'is', 'is not'] },
      ],
      defaultassignmentGroupingList: [
        { section: 'task', title: 'By Request Date', icon: 'calendar-right-arrow', id: 13, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: ['is', 'contains'] },
        { section: 'task', title: 'By Delivery Date', icon: 'delivery-date', id: 14, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'contains', filterTypeOptions: ['contains', 'does not contain'] },
        { section: 'task', title: 'By Parent Task', icon: 'arrow_top_bold', id: 15, showFilterInputMenu: false, showFilterSubMenu: false, filterType: 'is', filterTypeOptions: ['is', 'is not'] },
      ],
      activeFiltersList: [],
      showFiltersBottomSection: false,
      showFilterInputMenu: false,
      showTaskStatusSubmenuList: false,
      taskStatuses: ["Requested", "Confirmed", "Assigned", "In Progress", "On Hold", "Delivered", "Canceled"],
      showActionRequiredStatusSubmenuList: false,
      actionRequiredStatuses: ["Assign", "Follow Up", "Delivery"],
      projectSearch: '',
      personSearch: '',
      geoSearch: '',
      keywordSearch: '',
      mediaTypeSearch: '',
      requestTypeSearch: '',
      statusSearch: '',
      roleSearch: '',
    };
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  computed: {
    // Rows checked in the dashboard table (populated by ADTableV2). Drives the
    // visibility of the "Batch edit selected" option in the additional menu.
    ...mapGetters("spreadsheetUpload", ["selectedDashboardRows"]),
    assignmentGroupingList() {
      if (this.searchFilters) {
        return this.defaultassignmentGroupingList.filter(filter => filter.title.toLowerCase().includes(this.searchFilters.toLowerCase()));
      } else {
        return this.defaultassignmentGroupingList;
      }
    },
    presetsFiltersList() {
      let savedPresets = JSON.parse(localStorage.getItem('pm-dashboard-filters'));
      if (savedPresets) {
        this.savedPresetsList = savedPresets;
      }
      return Object.keys(this.savedPresetsList);
    },
    preperedProjectsList() {
      let projects = this.projectsList;
      if (this.projectSearch) {
        projects = projects.filter((project) =>
          (project.projectName || "")
            .toLowerCase()
            .includes(this.projectSearch.toLowerCase())
        );
      }
      return projects;
    },
    preparedGeos() {
      let geos = this.geos;
      if (this.geoSearch) {
        geos = geos.filter((geo) =>
          geo.toLowerCase().includes(this.geoSearch.toLowerCase())
        );
      }
      return geos;
    },
    preparedKeywords() {
      let keywords = this.keywords;
      if (this.keywordSearch) {
        keywords = keywords.filter((keyword) =>
          keyword.toLowerCase().includes(this.keywordSearch.toLowerCase())
        );
      }
      return keywords;
    },
    preparedMediaTypes() {
      let mediaTypes = this.mediaTypes;
      if (this.mediaTypeSearch) {
        mediaTypes = mediaTypes.filter((mediaType) =>
          mediaType.toLowerCase().includes(this.mediaTypeSearch.toLowerCase())
        );
      }
      return mediaTypes;
    },
    preparedRequestTypes() {
      let requestTypes = this.requestTypes;
      if (this.requestTypeSearch) {
        requestTypes = requestTypes.filter((requestType) =>
          requestType.toLowerCase().includes(this.requestTypeSearch.toLowerCase())
        );
      }
      return requestTypes;
    },
    preparedStatuses() {
      let statuses = this.statuses;
      if (this.statusSearch) {
        statuses = statuses.filter((status) =>
          status.toLowerCase().includes(this.statusSearch.toLowerCase())
        );
      }
      return statuses;
    },
    preparedRoles() {
      let roles = this.roles;
      if (this.roleSearch) {
        roles = roles.filter((role) =>
          role.toLowerCase().includes(this.roleSearch.toLowerCase())
        );
      }
      return roles;
    },
    preparedStaff() {
      let staffList = [];
      this.staff.forEach((staff) => {
        const colorItem = managersDesiredColors.find(el => el.name === staff.user.firstName + ' ' + staff.user.lastName);
        staffList.push({
          name: staff.user.firstName + ' ' + staff.user.lastName,
          id: staff.user.id,
          shortName: staff.user.firstName.charAt(0) + staff.user.lastName.charAt(0),
          color: colorItem ? colorItem.color : alphabetColors.find((color) => color.character === staff.user.firstName.charAt(0))?.color || "#9747FF"
        })
      });
      if (this.driNameSearch) {
        staffList = staffList.filter((staff) => staff.name.includes(this.driNameSearch));
      }
      return staffList;
    },
    // Person filter options — same staff source as DRI: multi-select, keyed by
    // full name (the values AssignmentDashboardV2's mapFiltersToProps resolves
    // back into staff objects for the personId query param). With no search
    // active, selected people are floated to the top of the list.
    preparedPersons() {
      let persons = this.staff.map((staff) => {
        const colorItem = managersDesiredColors.find(el => el.name === staff.user.firstName + ' ' + staff.user.lastName);
        return {
          name: staff.user.firstName + ' ' + staff.user.lastName,
          id: staff.user.id,
          shortName: staff.user.firstName.charAt(0) + staff.user.lastName.charAt(0),
          color: colorItem ? colorItem.color : alphabetColors.find((color) => color.character === staff.user.firstName.charAt(0))?.color || "#9747FF"
        };
      });
      if (this.personSearch) {
        persons = persons.filter((person) => person.name.toLowerCase().includes(this.personSearch.toLowerCase()));
      } else {
        // With no active search, float the already-selected people to the top
        // of the list (keeping each group's original order) so the current
        // selection is easy to see and toggle.
        const personFilter = this.activeFiltersList.find((f) => f.title === 'Person');
        const selected = Array.isArray(personFilter && personFilter.value)
          ? personFilter.value
          : [];
        if (selected.length) {
          persons = [
            ...persons.filter((person) => selected.includes(person.name)),
            ...persons.filter((person) => !selected.includes(person.name)),
          ];
        }
      }
      return persons;
    },
    assignmentFiltersList() {
      if (this.searchFilters) {
        return this.defaultAssignmentFiltersList.filter(filter => filter.title.toLowerCase().includes(this.searchFilters.toLowerCase()));
      } else {
        return this.defaultAssignmentFiltersList;
      }
    }
  },
  mounted() {
    this.restoreFiltersPreset();
  },
  methods: {
    // Debounced notifier: whenever the user commits a filter change (search
    // text, a value, a date, a project, a removal, etc.) tell the parent so it
    // can remap the query and refetch the table.
    onFilterChange() {
      clearTimeout(this.filterChangeTimeout);
      this.filterChangeTimeout = setTimeout(() => {
        this.$emit("filters-changed", {
          activeFilters: this.activeFiltersList,
          search: this.searchValue,
        });
      }, 300);
    },
    saveCurrentPreset() {
      const preset = {
        activeFilters: this.activeFiltersList.map((filter) => ({
          ...filter,
          showFilterInputMenu: false,
          showFilterSubMenu: false,
        })),
        search: this.searchValue,
      };
      localStorage.setItem(FILTERS_PRESET_KEY, JSON.stringify(preset));
      this.closeAdditionalMenu();
    },
    restoreFiltersPreset() {
      let preset = null;
      try {
        preset = JSON.parse(localStorage.getItem(FILTERS_PRESET_KEY));
      } catch (e) {
        preset = null;
      }
      if (!preset) return;

      this.searchValue = preset.search || "";

      const savedFilters = Array.isArray(preset.activeFilters)
        ? preset.activeFilters
        : [];
      if (savedFilters.length) {
        this.activeFiltersList = savedFilters.map((filter) => ({
          ...filter,
          showFilterInputMenu: false,
          showFilterSubMenu: false,
        }));
        this.showFiltersBottomSection = true;
        // Keep restored filters out of the "Add filter" menus to avoid dupes.
        this.activeFiltersList.forEach((filter) => {
          let idx = this.defaultAssignmentFiltersList.findIndex(
            (el) => el.id === filter.id
          );
          if (idx > -1) this.defaultAssignmentFiltersList.splice(idx, 1);
          idx = this.defaultassignmentGroupingList.findIndex(
            (el) => el.id === filter.id
          );
          if (idx > -1) this.defaultassignmentGroupingList.splice(idx, 1);
        });
      }
    },
    showCurrentFiltersModal() {
      this.closeAdditionalMenu();
      this.$emit('showCurrentFiltersModal', true);
    },
    callBatchEdit() {
      this.closeAdditionalMenu();
      this.$emit('batch-edit', this.selectedDashboardRows);
    },
    closeAdditionalMenu() {
      this.showAditionalOptionsSubMenuModal = false;
      this.showAditionalOptions = false;
    },
    closeAddFiltersMenu() {
      this.showAddFiltersMenu = false;
    },
    closeAddFiltersMenu2() {
      this.showAddFiltersMenu2 = false;
    },
    closeInputFilterModal(filter) {
      if (filter) {
        filter.showFilterInputMenu = false;
      } else {
        this.activeFiltersList.forEach(el => {
          el.showFilterInputMenu = false;
        });
      }
    },
    periodFormatter(value) {
      if (value) {
        const date = new Date(value);
        const day = date.toLocaleString('default', { day: 'numeric' });
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
        return `${month} ${day}, ${year}`;
      }
    },
    payPeriodFormatter(value) {
      if (value) {
        const date = new Date(value);
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
        return `${month} ${year}`;
      }
    },
    // Strip the leading "By " from a grouping title so the active "Group by"
    // chip reads as the plain field name (e.g. "By Delivery Date" → "Delivery Date").
    groupingLabel(title) {
      return (title || '').replace(/^By\s+/i, '');
    },
    showActiveFilterMenu(filter) {
      this.activeFiltersList.forEach(el => {
        if (el.id !== filter.id) {
          el.showFilterInputMenu = false;
        }
      });
      filter.showFilterInputMenu = !filter.showFilterInputMenu;
    },
    showActiveFilterSubMenu(filter) {
      this.activeFiltersList.forEach(el => {
        if (el.id !== filter.id) {
          el.showFilterSubMenu = false;
        }
      });
      filter.showFilterSubMenu = !filter.showFilterSubMenu;
    },
    setFilterType(filter, type) {
      filter.showFilterSubMenu = false;
      filter.filterType = type;
    },
    setDRIFilterValue(filter, value) {
      if (filter.value === '') {
        filter.value = [];
      }
      if (value) {
        if (!filter.value.includes(value.id)) {
          filter.value.push(value.id);
        } else {
          filter.value.splice(filter.value.indexOf(value.id), 1);
        }
      }
      this.onFilterChange();
    },
    setPersonFilterValue(filter, person) {
      // Multi-select: toggle each person by full name (the value the parent
      // matches against its staff list). Seed the empty default to an array on
      // first pick, mirroring the DRI filter.
      if (filter.value === '') {
        filter.value = [];
      }
      if (person) {
        if (!filter.value.includes(person.name)) {
          filter.value.push(person.name);
        } else {
          filter.value.splice(filter.value.indexOf(person.name), 1);
        }
      }
      this.onFilterChange();
    },
    setGeoFilterValue(filter, geo) {
      // Single-select: clicking the active value again clears the filter.
      filter.value = filter.value === geo ? '' : geo;
      this.geoSearch = '';
      this.onFilterChange();
    },
    setKeywordFilterValue(filter, keyword) {
      // Single-select: clicking the active value again clears the filter.
      filter.value = filter.value === keyword ? '' : keyword;
      this.keywordSearch = '';
      this.onFilterChange();
    },
    setMediaTypeFilterValue(filter, mediaType) {
      // Single-select: clicking the active value again clears the filter.
      filter.value = filter.value === mediaType ? '' : mediaType;
      this.mediaTypeSearch = '';
      this.onFilterChange();
    },
    setRequestTypeFilterValue(filter, requestType) {
      // Single-select: clicking the active value again clears the filter.
      filter.value = filter.value === requestType ? '' : requestType;
      this.requestTypeSearch = '';
      this.onFilterChange();
    },
    setStatusFilterValue(filter, status) {
      // Single-select: clicking the active value again clears the filter.
      filter.value = filter.value === status ? '' : status;
      this.statusSearch = '';
      this.onFilterChange();
    },
    setRoleFilterValue(filter, role) {
      // Single-select: clicking the active value again clears the filter.
      filter.value = filter.value === role ? '' : role;
      this.roleSearch = '';
      this.onFilterChange();
    },
    addTaskStatusFilterValue(filter, value) {
      if (filter.value === '') {
        filter.value = [];
      }
      if (value)
      if (!filter.value.includes(value)) {
        filter.value.push(value);
      } else {
        filter.value.splice(filter.value.indexOf(value), 1);
      }
      this.onFilterChange();
    },
    saveCurrentFiltersPreset(presetName) {
      if (!this.activeFiltersList.length) return;
      const savedPresets = JSON.parse(localStorage.getItem('pm-dashboard-filters'));
      if (savedPresets) {
        savedPresets[presetName] = this.activeFiltersList;
        localStorage.setItem('pm-dashboard-filters', JSON.stringify(savedPresets));
      } else {
        localStorage.setItem('pm-dashboard-filters', JSON.stringify({ [presetName]: this.activeFiltersList }));
      }
    },
    removePreset(preset) {
      const savedPresets = JSON.parse(localStorage.getItem('pm-dashboard-filters'));
      if (savedPresets) {
        delete savedPresets[preset];
        localStorage.setItem('pm-dashboard-filters', JSON.stringify(savedPresets));
        this.$delete(this.savedPresetsList, preset);
      }
    },
    useFilterPreset(preset) {
      this.activeFiltersList = [];
      this.activeFiltersList = this.savedPresetsList[preset];
    },
    addFilter(filter) {
      console.log('filter', filter);
      console.log('activeFiltersList', this.activeFiltersList);
      this.showFiltersBottomSection = true;
      // Close the "Add filter/grouping" menus once a selection is made.
      this.closeAddFiltersMenu();
      this.closeAddFiltersMenu2();
      this.searchFilters = '';
      if (filter.section === "task") {
        if (this.activeFiltersList.length > 0 && this.activeFiltersList[0].section === "task") {
          this.activeFiltersList.splice(0, 1, filter)
        } else {
          this.activeFiltersList.unshift(filter)
        }
        return;
      }
      this.activeFiltersList.push({
        ...filter,
        value: '',
      });
      const searchedItem = this.defaultAssignmentFiltersList.find(el => el.id == filter.id);
      if (searchedItem) {
        this.defaultAssignmentFiltersList.splice(this.defaultAssignmentFiltersList.indexOf(searchedItem), 1);
      } else {
        const searchedItem = this.defaultassignmentGroupingList.find(el => el.id == filter.id);
        this.defaultassignmentGroupingList.splice(this.defaultassignmentGroupingList.indexOf(searchedItem), 1);
      }
    },
    removeFilter(filter) {
      this.activeFiltersList.splice(this.activeFiltersList.indexOf(filter), 1);
      if (filter.section === 'assignment') {
        this.defaultAssignmentFiltersList.push({
          ...filter
        })
      } else {
        this.defaultassignmentGroupingList.push({
          ...filter
        })
      }
      this.onFilterChange();
    },
    clearFilterValue(filter) {
      if (typeof filter.value === 'string') {
        filter.value = '';
      } else {
        filter.value = [];
      }
      this.onFilterChange();
    },
    clearAll() {
      this.activeFiltersList.forEach(el => {
        if (el.section === 'assignment') {
          this.defaultAssignmentFiltersList.push({
            ...el
          })
        } else {
          this.defaultassignmentGroupingList.push({
            ...el
          })
        }
      });
      this.activeFiltersList = [];
      this.searchValue = '';
      this.onFilterChange();
    }
  }
};
</script>

<style lang="scss" scoped>
.ad-filters {
  font-family: 'Roboto', sans-serif !important;
  box-shadow: 0px 0px 10px 0px #0000001A;
  width: 100%;
  background-color: #FFFFFF;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  &__top {
    height: 60px;
    padding: 12px 16px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-left {
      display: flex;
      align-items: center;
      &--search {
        width: 320px;
        .search-container {
          display: flex;
          align-items: center;
          background-color: #f8f9fa;
          border: 1px solid #EDEFF3;
          border-radius: 8px;
          width: 320px;
          height: 36px;
        }
        .search-container input {
          border: none;
          outline: none;
          background: none;
          flex: 1;
          padding: 8px;
          font-size: 16px;
          color: #697A9B;
        }
        .search-container .icon {
          color: #a0a0a0;
          margin-right: 10px;
          margin-left: 12px;
          font-size: 20px;
          width: 16px;
          height: 16px;
        }
      }
      &--delimetr {
        width: 1px;
        height: 24px;
        background-color: #EDEFF3;
        border-left: 1px solid #EDEFF3;
        margin-left: 12px;
      }
      &--add {
        margin-left: 12px;
        position: relative;
        .submenu {
          position: absolute;
          left: -100px;
          top: 50px;
          background-color: #ffffff;
          min-width: 190px;
          width: 302px;
          border-radius: 10px;
          box-shadow: 0px 1px 6px 2px #00000026;
          padding: 10px 5px;
          font-family: "Roboto";
          font-size: 14px;
          font-weight: 500;
          color: #697A9B;
          z-index: 10;
          display: flex;
          flex-direction: column;
        }
        .submenu-item {
          background: none;
          border: none;
          width: 100%;
          text-align: left;
          cursor: pointer;
          font-size: 14px;
          color: #333;
          font-family: "Roboto";
          font-size: 14px;
          font-style: italic;
          font-weight: 300;
          display: flex;
          &--text {
            margin-bottom: 0px;
            width: 90%;
          }
          &--button {
            margin-top: 3px;
            width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 2px 2px 2px;
            border-radius: 4px;
            width: 10%;
            .icon {
              width: 10px;
              height: 12px;
              font-size: 17px;
            }
            &:hover {
              background-color: #DEDEDE;
            }
          }
          &--search {
            width: 100%;
            .search-container {
              display: flex;
              align-items: center;
              background-color: #f8f9fa;
              border: 1px solid #EDEFF3;
              border-radius: 8px;
              width: 100%;
              height: 36px;
            }
            .search-container input {
              border: none;
              outline: none;
              background: none;
              flex: 1;
              padding: 8px;
              font-size: 16px;
              color: #697A9B;
            }
            .search-container .icon {
              color: #a0a0a0;
              margin-right: 10px;
              margin-left: 12px;
              font-size: 20px;
              width: 16px;
              height: 16px;
            }
          }
          &--title {
            padding: 8px 5px;
            border-radius: 4px;
            width: 100%;
            text-align: left;
            &--text {
              font-family: "Roboto";
              font-size: 14px;
              font-weight: 500;
              color: #697A9B;
              margin-bottom: 0px;
            }
          }
          &--filter {
            border-radius: 4px;
            width: 100%;
            padding: 8px 15px;
            display: flex;
            align-items: center;
            &--icon {
              margin-right: 8px;
            }
            &--text {
              font-family: "Roboto";
              font-size: 14px;
              font-weight: 500;
              color: #697A9B;
              margin-bottom: 2px;
            }
            &:hover {
              background-color: #f2f2f2;
              cursor: pointer;
            }
          }
        }
        .submenu-item:hover {
          background-color: #f1f1f1;
        }
        &--button {
          display: flex;
          align-items: center;
          border: none;
          font-family: "Roboto", sans-serif;
          color: #3D475C;
          padding: 10px 12px;
          border-radius: 8px;
          & span {
            margin-top: 4px;
            font-family: "Roboto", sans-serif;
            font-size: 16px;
            font-weight: 500;
          }
          & .icon {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }
          &:hover {
            cursor: pointer;
            background-color: #f2f2f2;
          }
        }
      }
    }
    &-right {
      display: flex;
      align-items: center;
      &--new-task {
        margin-right: 12px;
        &--button {
          display: flex;
          align-items: center;
          border: none;
          border-radius: 8px;
          width: 180px;
          padding: 10px 12px;
          font-family: "Roboto", sans-serif;
          color: #FFF;
          background-color: #006BD6;
          & span {
            margin-left: 8px;
            font-size: 16px;
            font-weight: 500;
            line-height: 16px;
            text-align: left;
          }
          & .icon {
            width: 16px;
            height: 16px;
            font-size: 20px;
          }
        }
      }
      &--options {
        position: relative;
        &--button {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #E0E4EB;
          border-radius: 8px;
          width: 36px;
          height: 36px;
          padding: 10px;
          & .icon {
            width: 16px;
            height: 16px;
            font-size: 20px;
          }
        }
        & .options-dropdown {
          position: absolute;
          top: 40px;
          right: 0;
          width: 200px;
          background-color: #fff;
          border-radius: 10px;
          box-shadow: 0px 1px 6px 2px #00000026;
          padding: 10px 5px;
          font-family: "Roboto";
          font-size: 14px;
          font-weight: 500;
          color: #697A9B;
          z-index: 10;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-around;
          &__item {
            padding: 8px 5px;
            width: 100%;
            text-align: left;
            &:hover {
              background-color: #f2f2f2;
            }
          }
          .with-submenu {
            position: relative;
          }
          .submenu {
            position: absolute;
            left: -199px;
            top: 0;
            background-color: #ffffff;
            min-width: 190px;
            border-radius: 10px;
            box-shadow: 0px 1px 6px 2px #00000026;
            padding: 10px 5px;
            font-family: "Roboto";
            font-size: 14px;
            font-weight: 500;
            color: #697A9B;
            z-index: 10;
            display: flex;
            flex-direction: column;
          }
          .submenu-item {
            background: none;
            border: none;
            padding: 8px 12px;
            width: 100%;
            text-align: left;
            cursor: pointer;
            font-size: 14px;
            color: #333;
            font-family: "Roboto";
            font-size: 14px;
            font-style: italic;
            font-weight: 300;
            display: flex;
            &--text {
              margin-bottom: 0px;
              width: 90%;
            }
            &--button {
              margin-top: 3px;
              width: 18px;
              height: 18px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 4px 2px 2px 2px;
              border-radius: 4px;
              width: 10%;
              .icon {
                width: 10px;
                height: 12px;
                font-size: 17px;
              }
              &:hover {
                background-color: #DEDEDE;
              }
            }
          }
          .submenu-item:hover {
            background-color: #f1f1f1;
          }
        }
      }
    }
  }
  &__bottom {
    min-height: 60px;
    padding: 12px 16px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 12px;
    &--list {
      & .with-submenu {
        position: relative;
      }
      & .list-item {
        display: flex;
        align-items: center;
        border-bottom: none;
        border: 1px solid #E0E4EB;
        border-radius: 8px;
        &--icon {
          padding: 8px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          & .icon {
            width: 16px;
            height: 16px;
            font-size: 20px;
          }
          &-text {
            margin-bottom: 0;
            margin-top: 3px;
            margin-left: 6px;
            font-family: "Roboto";
            font-size: 14px;
            font-weight: 400;
            color: #525F7A;
          }
          &:hover {
            cursor: pointer;
          }
        }
        &--text {
          border-left: 1px solid #E0E4EB;
          padding: 8px 10px;
          background-color: #F9FAFB;
          &:hover {
            cursor: pointer;
          }
          & .users-list {
            &__item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              &:hover {
                cursor: pointer;
                background-color: #f8f9fa;
              }
              &--more {
                  margin-bottom: 0px;
                }
              &--check {
                display: flex;
                align-items: center;
              }
              &-container {
                display: flex;
                align-items: center;
                &--avatar {
                  background-color: #006BD6;
                  color: #fff;
                  width: 24px;
                  height: 24px;
                  padding: 8px 6px 8px 6px;
                  border-radius: 18px;
                  margin-right: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-family: "Roboto";
                  font-size: 12px;
                  font-weight: 400;
                  letter-spacing: 0.0089em;
                }
                &--name {
                  color: #1F242E;
                  margin-bottom: 0;
                  font-family: "Roboto";
                  font-size: 14px;
                  font-weight: 400;
                }
              }
            }
          }
        }
        &--remove {
          border-left: 1px solid #E0E4EB;
          padding: 8px 10px;
          margin-top: 3px;
          &:hover {
            cursor: pointer;
          }
        }
        & .submenu {
          position: absolute;
          left: 0px;
          top: 45px;
          background-color: #ffffff;
          min-width: 190px;
          border-radius: 10px;
          box-shadow: 0px 1px 6px 2px #00000026;
          padding: 10px 5px;
          font-family: "Roboto";
          font-size: 14px;
          font-weight: 500;
          color: #697A9B;
          z-index: 10;
          display: flex;
          width: 300px;
          flex-direction: column;
          &__value {
            width: 100%;
            &--container {
              display: flex;
              align-items: center;
              background-color: #f8f9fa;
              border: 1px solid #EDEFF3;
              border-radius: 8px;
              width: 100%;
              min-height: 36px;
              & input {
                border: none;
                outline: none;
                background: none;
                flex: 1;
                padding: 8px;
                font-size: 16px;
                color: #697A9B;
              }
              & .icon {
                color: #a0a0a0;
                margin-right: 10px;
                margin-left: 12px;
                font-size: 20px;
                width: 16px;
                height: 16px;
                &:hover {
                  cursor: pointer;
                }
              }
              & .users-container {
                display: flex;
                align-items: center;
                background-color: #f8f9fa;
                border: 1px solid #EDEFF3;
                border-radius: 8px;
                width: 100%;
                height: 36px;
                & input {
                  border: none;
                  outline: none;
                  background: none;
                  flex: 1;
                  padding: 8px;
                  font-size: 16px;
                  color: #697A9B;
                }
                & .icon {
                  color: #a0a0a0;
                  margin-right: 10px;
                  margin-left: 12px;
                  font-size: 20px;
                  width: 16px;
                  height: 16px;
                  &:hover {
                    cursor: pointer;
                  }
                }
              }
              & .date-picker {
                position: absolute;
                width: 330px;
                background-color: #fff;
              }
              & .users-list {
                width: 100%;
                display: flex;
                flex-direction: column;
                margin-top: 8px;
                &__item {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 4px;
                  padding: 2px 0;
                  width: 100%;
                  &:hover {
                    cursor: pointer;
                    background-color: #f8f9fa;
                  }
                  &--check {
                    display: flex;
                    align-items: center;
                  }
                  &-container {
                    display: flex;
                    align-items: center;
                    &--avatar {
                      background-color: #006BD6;
                      color: #fff;
                      width: 24px;
                      height: 24px;
                      padding: 8px 6px 8px 6px;
                      border-radius: 18px;
                      margin-right: 10px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-family: "Roboto";
                      font-size: 12px;
                      font-weight: 400;
                      letter-spacing: 0.0089em;
                    }
                    &--name {
                      color: #1F242E;
                      margin-bottom: 0;
                      font-family: "Roboto";
                      font-size: 14px;
                      font-weight: 400;
                    }
                  }
                }
              }
            }
            & .container-users {
              flex-direction: column;
              border: none;
              background-color: #fff;
            }
          }
        }
        .submenu-item {
          background: none;
          border: none;
          padding: 8px 5px;
          width: 100%;
          text-align: left;
          cursor: pointer;
          font-size: 14px;
          color: #333;
          font-family: "Roboto";
          font-size: 14px;
          font-style: italic;
          font-weight: 300;
          display: flex;
          align-items: center;
          &--text {
            font-family: "Roboto";
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
            text-align: left;
          }
          &--dropdown {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 5px;
            & .sec-submenu--dropdown-text {
              font-family: "Roboto";
              font-size: 14px;
              font-weight: 600;
              margin-bottom: 0;
            }
            & .sec-submenu--dropdown-icon {
              font-family: "Roboto";
              font-size: 14px;
              font-weight: 600;
              margin-bottom: 0;
            }
          }
          & .sec-submenu {
            position: absolute;
            left: 0px;
            top: 45px;
            background-color: #ffffff;
            min-width: 190px;
            border-radius: 10px;
            box-shadow: 0px 1px 6px 2px #00000026;
            padding: 10px 5px;
            font-family: "Roboto";
            font-size: 14px;
            font-weight: 500;
            color: #697A9B;
            z-index: 10;
            display: flex;
            flex-direction: column;
            &--option {
              margin-bottom: 0px;
              padding: 8px 5px;
              font-family: "Roboto";
              font-size: 14px;
              font-weight: 500;
              color: #697A9B;
            }
          }
        }
      }
    }
  }
}

/* Active "Group by" chip (task-section grouping) in the filters bottom row:
   label · grouping icon + value · remove, mirroring the assignment filter chips. */
.ad-filters__bottom .list-item--group-by {
  .list-item--text {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .group-by-value--name {
    margin-bottom: 0;
    color: #1F242E;
    font-family: "Roboto";
    font-size: 14px;
    font-weight: 400;
  }
}

/* GEO / Keyword / Media Type / Request Type / Project filter dropdowns: cap the
   list height so ~7 items show and the rest scrolls vertically when there isn't
   enough space. */
.geo-list,
.enum-list,
.project-list,
.person-list {
  max-height: 280px;
  overflow-y: auto;
  padding-right: 4px;
}

.submenu-transition-enter-active, .submenu-transition-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Initial state when entering */
.submenu-transition-enter {
  opacity: 0;
  transform: translateY(-10px);
}

/* Final state when leaving */
.submenu-transition-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>